import axios from 'axios'
export const getContentPost = async (url) => {
   const res = await axios.get(url)
   return res
}
export const getNews = async(url, params) =>{
   const res = await axios.get(url, { params: params })
   return res
}
export const getPictures = async(url) =>{
   const res = await axios.get(url)
   return res
}
export const getArtistsCategories = async(url, params)=>{
   const res = await axios.get(url, {params:params})
   return res
}
export const getFeatureMedia =async(url)=>{
   const res = await axios.get(url)
   return res
}
